<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      port:'pcPort'
    }
  },
  created(){
    let str = window.location.href;
    if(window.location.href.indexOf('http://')!=-1){
      window.location.href = 'https://www.anmav.cn'
    }
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        sessionStorage.setItem('openPort','mobilePort');
        this.port = 'mobilePort';
    } else {
      sessionStorage.setItem('openPort','pcPort')
      this.port = 'pcPort'
    }
    console.log(this.port)
    if(this.port == 'pcPort'){
      let _html = document.getElementsByTagName('html')[0]
      _html.style.minWidth = '995px'
    }
  }
}
</script>

<style>
    .el-cascader{
      width: 100%;
    }
    .el-input__inner{
      border: 0;
      padding-left: 0;
      font-size: 20px;
    }
    .el-cascader__label{
      padding-left: 0;
      font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue